import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../models';

@Pipe({
    name: 'customerContactDetails',
    standalone: true
})
export class CustomerContactDetailsPipe implements PipeTransform {
  validContactDetailsFields = ['telephone', 'alt_telephone', 'mobile', 'email'];
  transform(value: Customer): any {
    let address = [];
    this.validContactDetailsFields.forEach((field) => {
      if (value[field]) {
        address.push(value[field]);
      }
    });
    return address.join(' - ');
  }
}
